<template>
  <div class="text" :class="{
    'text--center': center,
    'text--small': small,
    'text--big': big,
    'text--uppercase': uppercase,
    'text--alternative': alternative,
  }">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'VText',

  props: {
    center: {
      type: Boolean,
      default: false,
    },

    small: {
      type: Boolean,
      default: false,
    },

    big: {
      type: Boolean,
      default: false,
    },

    uppercase: {
      type: Boolean,
      default: false,
    },

    alternative: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.text {
  font-family: $fontFamily;
  font-size: font($textFontSizeMin, $textFontSizeMax);
  line-height: 1.25em;
  color: $textColor;

  &:not(:first-child) {
    margin-top: $gridGutter;
  }

  ::v-deep a {
    color: $textAnchorColor;
    text-decoration: none;

    border-bottom: 1px solid $textAnchorColor;

    &:hover {
      color: $textAnchorColorHover;
      border-bottom: 1px solid $textAnchorColorHover;
    }
  }

  ::v-deep span,
  &--alternative {
    color: $textAlternativeColor;
  }

  &--center {
    text-align: center;
  }

  &--small {
    font-size: font($textFontSizeSmallMin, $textFontSizeSmallMax);
  }

  &--big {
    font-size: font($textFontSizeBigMin, $textFontSizeBigMax);
  }

  &--uppercase {
    text-transform: uppercase;
  }
}
</style>
